var _defs, _g, _image, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMocaDoor4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 614 370.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.632,
    y: 54.956,
    width: 130.858,
    height: 228.603,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.752,329.284c79.968,26.302,42.086,33.028,138.227,39.233,83.641,5.395,188.209-5.845,305.698-2.182,75.384,2.352,127.398-28.144,130.05-51.133,2.652-22.989-13.211-35.87-83.38-45.288-66.516-8.928-65.365-29.935-273.051-24.03-78.947,2.252-99.504,7.156-171.555,14.082-72.051,6.926-125.986,43.036-46.019,69.339l.03-.02h0Z",
    fill: "#f4aafb",
    isolation: "isolate",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.674,328.133c79.968,25.952,37.101,25.482,133.253,34.99,83.641,8.277,151.678-8.197,269.177.06,75.384,5.294,140.619-31.597,143.261-51.113,2.652-19.516-8.627-32.457-78.767-43.567-66.516-10.529-56.928-21.048-264.613-25.101-78.947-1.531-83.06,15.063-155.091,17.825-72.031,2.762-127.197,40.915-47.22,66.866v.04h0Z",
    fill: "#f4aafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.739,299.339c-3.753,10.159-43.026,13.611-78.106,23.89-24.441,7.176-27.453,14.142-107.681,22.069-69.799,6.886-203.522-10.119-257.087-12.771-50.312-2.492-83.2-16.694-78.106-30.816,8.337-23.13,52.024-24.771,81.149-32.577,50.713-13.571,31.387-21.108,204.703-24.481,65.866-1.291,111.464,18.756,155.481,21.698,42.296,2.822,86.053,15.713,79.677,32.968l-.03.02h0Z",
    fill: "#1b68db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.226,244.302c3.143,4.234,8.597,15.693-3.983,20.697-12.591,5.024-23.34,2.102-30.546-4.904-7.206-6.986-4.013-16.634,8.577-21.658,12.591-5.024,22.809,1.611,25.962,5.845v.02h-.01Z",
    fill: "#1b68db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.831,245.473c2.652,2.182,4.434,10.219-3.723,12.511-8.157,2.292-15.783,5.114-20.317.29-4.564-4.844-1.912-12.12,6.235-14.412,8.157-2.292,13.792-1.691,17.805,1.611Z",
    fill: "#a9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.397,266.461c2.832,2.212,7.967,9.888,1.471,14.432-6.526,4.534-13.662,4.043-19.536.651s-7.156-9.968-.661-14.512c6.526-4.534,15.913-2.762,18.726-.57Z",
    fill: "#1b68db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.724,269.193c2.072,1.001,4.904,5.685.47,8.037s-8.447,4.964-12.24,2.572c-3.803-2.392-3.803-7.116.631-9.458,4.434-2.352,7.967-2.652,11.119-1.121l.03-.02s-.01-.01-.01-.01Z",
    fill: "#a9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.271,288.82c-8.837,8.767-37.362,19.667-101.306,24.411-40.744,3.013-118.71,11.37-187.849,11.37s-79.447-11.66-125.896-19.146c-31.487-5.064-46.539-26.793,25.081-32.447,31.206-2.462,58.499-7.286,89.936-13.341,3.363-.18,86.053-4.314,97.082-4.314,5.525,0,126.717,12.08,149.686,13.732,37.872,2.722,62.122,10.949,53.285,19.717l-.03.02h.01Z",
    fill: "#061c3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.654,287.629c-5.435,6.465-38.893,14.642-90.466,17.575-45.258,2.572-101.756-2.962-161.937-1.471-55.417,1.371-83.701-1.511-104.338-7.777-22.829-6.906-22.259-13.291,35.17-18.025,25.021-2.052,249.741-2.582,268.156-1.211,30.396,2.292,56.888,6.766,53.395,10.899l.03.02-.01-.01h0Z",
    fill: "#a9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.936,315.202c-74.623,10.909-118.78,12.931-238.231,5.845-263.142-15.593-137.056-44.778-85.342-48.291,51.704-3.513,220.066-3.863,323.583,3.703,103.517,7.556,74.623,27.833,0,38.743h-.01Z",
    fill: "none",
    stroke: "#a9e9ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.358,342.805l-1.151.901c-.26.18-.45.41-.55.651-.16.24-.24.51-.24.801s.05.55.24.801c.1.24.29.47.55.651l.52.33c.42.18.841.29,1.311.29l.711-.08c.45-.1.841-.26,1.151-.53l1.151-.901c.26-.18.45-.41.55-.651.16-.24.24-.51.24-.801s-.05-.55-.24-.801c-.1-.24-.29-.47-.55-.651l-.52-.33c-.42-.18-.841-.29-1.311-.29l-.711.08c-.45.1-.841.27-1.151.53Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.647,352.043h-1.151c-.37,0-.711.04-1.021.18-.32.08-.601.22-.841.43-.26.18-.45.41-.55.651-.16.24-.24.51-.24.801l.11.55c.13.35.34.651.681.901l.52.33c.42.18.841.29,1.311.29h1.151c.37,0,.711-.04,1.021-.18.31-.08.601-.23.841-.43.26-.18.45-.41.55-.651.16-.24.24-.51.24-.801l-.11-.55c-.13-.35-.34-.651-.681-.901l-.52-.33c-.42-.18-.841-.29-1.311-.29Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.049,343.236c-.37.59-.731,1.211-1.101,1.802-.18.23-.29.49-.31.761-.08.26-.05.55.05.821.08.27.24.49.47.691.18.22.42.39.731.53l.631.21c.47.1.921.1,1.391,0l.631-.21c.39-.18.711-.43.941-.731.37-.59.731-1.201,1.101-1.802.18-.22.29-.49.31-.761.08-.27.05-.55-.05-.821-.08-.27-.24-.49-.47-.691-.18-.23-.42-.39-.731-.53l-.631-.2c-.47-.1-.921-.1-1.391,0l-.631.2c-.39.18-.711.43-.941.731Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.394,355.746h-.58c-.18,0-.34.02-.5.08-.16.04-.31.1-.42.21-.13.1-.21.2-.26.33-.08.12-.13.24-.1.39l.05.27c.05.16.18.33.34.45l.26.16c.21.1.42.14.651.14h.58c.18,0,.34-.02.5-.08.16-.04.32-.1.42-.21.13-.1.21-.2.26-.33.08-.12.13-.24.1-.39l-.05-.27c-.05-.16-.18-.33-.34-.45l-.26-.16c-.21-.1-.42-.14-.651-.14Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.765,315.202c.18,1.351.37,2.672.55,4.023.03.29.13.51.39.711.24.18.601.31.921.31.651-.02,1.391-.45,1.311-1.021-.18-1.351-.37-2.682-.55-4.023-.03-.29-.13-.51-.39-.711-.24-.18-.601-.31-.921-.31-.651.02-1.391.45-1.311,1.021Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.502,317.484c-.731.24-1.491.49-2.232.741l-.31.1c-.29.1-.52.39-.601.611-.08.24-.05.57.13.801.18.23.45.41.791.47l.34.04c.24,0,.45-.04.661-.14.731-.24,1.491-.49,2.232-.741l.31-.1c.29-.1.52-.39.601-.611.08-.24.05-.57-.13-.801-.18-.22-.45-.41-.791-.47l-.34-.04c-.24,0-.45.04-.651.14h-.01Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552.505,338.071c.18.31.39.59.581.901.08.12.18.23.34.29.13.08.26.14.45.18.18.04.34.04.52,0,.18,0,.34-.04.5-.12l.26-.16c.16-.12.26-.29.34-.45l.05-.27c0-.18-.05-.35-.18-.51-.18-.31-.39-.59-.581-.901-.08-.12-.18-.23-.34-.29-.13-.08-.26-.14-.45-.18-.18-.04-.34-.04-.52,0-.18,0-.34.04-.5.12l-.26.16c-.16.12-.26.29-.34.45l-.05.27c0,.18.05.35.18.51Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.516,336.54h-2.282c-.34,0-.681.12-.921.31-.23.18-.39.47-.39.711s.13.53.39.711.58.31.921.31h2.282c.34,0,.681-.12.921-.31.24-.18.39-.47.39-.711s-.13-.53-.39-.711-.58-.31-.921-.31Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.057,360.14l-1.731.45c-.32.08-.601.24-.791.47-.11.12-.16.24-.16.39-.03.14-.03.27,0,.41.1.24.29.49.601.611s.681.18,1.021.1l1.731-.45c.31-.08.601-.24.791-.47.11-.12.16-.24.16-.39.03-.14.03-.27,0-.41-.11-.25-.29-.49-.601-.611s-.681-.18-1.021-.1Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.427,348.29l-1.151.45c-.16.06-.29.14-.37.26-.1.1-.18.21-.24.35-.05.14-.05.26,0,.41,0,.14.05.26.16.39l.21.2c.16.12.37.2.58.27l.34.04c.24,0,.45-.04.651-.14l1.151-.45c.16-.06.29-.14.37-.27.1-.1.18-.2.24-.35.05-.14.05-.27,0-.41,0-.14-.05-.27-.16-.39l-.21-.2c-.16-.12-.37-.2-.58-.26l-.34-.04c-.24,0-.45.04-.651.14Z",
    fill: "#fbe3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.656,310.638c-.6.04-1.151.14-1.681.39s-.921.57-1.231.961c-.1.12-.16.25-.16.39-.03.14-.03.27,0,.41.05.14.13.24.24.35.1.1.21.21.37.27.31.12.681.18,1.021.1s.6-.24.791-.47c.05-.06.08-.1.13-.16l-.21.2c.1-.12.26-.22.39-.31l-.26.16c.16-.1.34-.18.52-.25l-.31.1c.18-.06.37-.1.581-.12l-.34.04h.13c.18,0,.34-.02.5-.08.16-.04.31-.1.42-.2.13-.1.21-.2.26-.33.08-.12.13-.24.11-.39,0-.27-.13-.53-.39-.711s-.581-.33-.921-.31l.05-.04h-.01Z",
    fill: "#6ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.496,341.744l-.58-.45s-.26-.16-.42-.2c-.16-.06-.32-.1-.5-.08-.18,0-.34.02-.5.08-.16.04-.31.1-.42.2l-.21.2c-.13.16-.18.33-.18.51l.05.27c.05.16.18.33.34.45l.58.45s.26.16.42.2c.16.06.31.1.5.08.18,0,.34-.02.5-.08.16-.04.32-.1.42-.2l.21-.2c.13-.16.18-.33.18-.51l-.05-.26c-.05-.16-.18-.33-.34-.45v-.01h0Z",
    fill: "#6ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.413,332.757c1.681,0,1.681-2.042,0-2.042s-1.681,2.042,0,2.042Z",
    fill: "#6ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.939,334.428l-1.731.45c-.31.08-.601.24-.791.47-.11.12-.16.24-.16.39-.03.14-.03.27,0,.41.11.24.29.49.601.611s.681.18,1.021.1l1.731-.45c.31-.08.601-.24.791-.47.11-.12.16-.24.16-.39.03-.14.03-.27,0-.41-.1-.24-.29-.49-.601-.611s-.681-.18-1.021-.1Z",
    fill: "#6ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.778,295.575c-1.391.801-2.592,1.802-3.463,2.983-.34.47-.16,1.141.47,1.391.631.24,1.441.12,1.782-.37.26-.35.52-.671.841-.981l-.21.2c.55-.55,1.211-1.061,1.912-1.491l-.26.16s.16-.08.24-.14c.29-.16.5-.33.601-.611.08-.24.05-.57-.13-.801-.18-.22-.45-.41-.791-.47s-.731-.06-1.021.1l.03.02v.01h0Z",
    fill: "#6ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.916,308.496v.45c0,.14.03.27.1.39.05.12.13.25.26.33.13.1.26.16.42.2.16.06.31.1.5.08l.34-.04c.21-.04.42-.14.58-.27l.21-.2c.13-.16.18-.33.18-.51v-.45c0-.14-.03-.27-.1-.39-.05-.12-.13-.24-.26-.33-.13-.1-.26-.16-.42-.2-.16-.06-.31-.1-.5-.08l-.34.04c-.21.04-.42.14-.58.27l-.21.2c-.13.16-.18.33-.18.51Z",
    fill: "#6ea9ff"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 183,
    height: 309,
    transform: "translate(200.457 15.058) scale(.865)",
    xlinkHref: "data:image/png;base64,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"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.842,
    y: 193.406,
    width: 107.332,
    height: 26.604,
    transform: "translate(108.202 -92.557) rotate(24.142)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m203.718,220.24c-4.079,9.101-17.127,11.135-17.127,11.135-.891.139-2.02-.367-2.509-1.125,0,0-7.165-11.093-3.086-20.194s17.127-11.135,17.127-11.135c.891-.139,2.02.367,2.509,1.125,0,0,7.165,11.093,3.086,20.194Z",
    fill: "#fcc100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.718,220.24c-4.079,9.101-17.127,11.135-17.127,11.135-.891.139-2.02-.367-2.509-1.125,0,0-7.165-11.093-3.086-20.194s17.127-11.135,17.127-11.135c.891-.139,2.02.367,2.509,1.125,0,0,7.165,11.093,3.086,20.194Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.651,217.072c-2.179,4.861-6.683,6.359-6.683,6.359-.856.285-1.848-.16-2.204-.988,0,0-1.879-4.36.3-9.22,2.179-4.861,6.683-6.359,6.683-6.359.856-.285,1.848.16,2.204.988,0,0,1.879,4.36-.3,9.22Z",
    fill: "#e20616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.651,217.072c-2.179,4.861-6.683,6.359-6.683,6.359-.856.285-1.848-.16-2.204-.988,0,0-1.879-4.36.3-9.22,2.179-4.861,6.683-6.359,6.683-6.359.856-.285,1.848.16,2.204.988,0,0,1.879,4.36-.3,9.22Z",
    fill: "none",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m205.53,163.613s-23.452,9.911-32.31,29.677c-1.386,3.093,21.29,5.551,21.29,5.551l11.02-35.228Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.029,165.555c-1.064-4.98-8.519-7.718-8.519-7.718,0,0-7.429-3.725-11.429-1.223-5.991,3.747-24.467,18.002-27.297,47.93l14.816,6.641,9.974,4.47c20.457-22.028,23.932-43.19,22.455-50.101Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.885,151.174c-2.794,1.649-5.778,3.768-8.338,6.38l21.803,9.772s.374-4.194-.765-10.345c-1.075-5.802-7.618-8.807-12.7-5.807Z",
    fill: "#e4201e",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.922,189.087c-1.485,4.607-2.598,9.744-3.138,15.457l14.816,6.641,9.974,4.47c3.902-4.201,7.177-8.369,9.927-12.415l-31.579-14.154Z",
    fill: "#e4201e",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m281.822,255.246c-4.079,9.101,3.086,20.194,3.086,20.194.489.757,1.618,1.264,2.509,1.125,0,0,13.048-2.033,17.127-11.135,4.079-9.101-3.086-20.194-3.086-20.194-.489-.757-1.618-1.264-2.509-1.125,0,0-13.048,2.033-17.127,11.135Z",
    fill: "#fcc100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.822,255.246c-4.079,9.101,3.086,20.194,3.086,20.194.489.757,1.618,1.264,2.509,1.125,0,0,13.048-2.033,17.127-11.135,4.079-9.101-3.086-20.194-3.086-20.194-.489-.757-1.618-1.264-2.509-1.125,0,0-13.048,2.033-17.127,11.135Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m288.889,258.413c-2.179,4.861-.3,9.22-.3,9.22.357.828,1.349,1.273,2.204.988,0,0,4.505-1.498,6.683-6.359,2.179-4.861.3-9.22.3-9.22-.357-.828-1.349-1.273-2.204-.988,0,0-4.505,1.498-6.683,6.359Z",
    fill: "#e20616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.889,258.413c-2.179,4.861-.3,9.22-.3,9.22.357.828,1.349,1.273,2.204.988,0,0,4.505-1.498,6.683-6.359,2.179-4.861.3-9.22.3-9.22-.357-.828-1.349-1.273-2.204-.988,0,0-4.505,1.498-6.683,6.359Z",
    fill: "none",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m322.886,216.211s8.208,24.1-.652,43.866c-1.386,3.093-18.311-12.197-18.311-12.197l18.963-31.669Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.798,199.963c4.426-2.519,11.429,1.223,11.429,1.223,0,0,7.724,3.067,8.519,7.718,1.19,6.966,2.844,30.243-17.613,52.271l-14.816-6.641-9.974-4.47c2.83-29.928,16.314-46.605,22.455-50.101Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.28,200.204c.628,3.183,1.032,6.82.787,10.469l-21.803-9.772s2.882-3.07,8.231-6.313c5.046-3.059,11.643-.174,12.786,5.615Z",
    fill: "#e4201e",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.583,248.546c-2.451,4.174-5.545,8.424-9.45,12.628l-14.816-6.641-9.974-4.47c.54-5.708,1.471-10.927,2.661-15.671l31.579,14.154Z",
    fill: "#e4201e",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("path", {
    d: "m297.33,230.972s8.978.586,14.161-5.179l18.529.313s1.112,10.226-10.028,20.317c-11.139,10.091-31.137,11.609-31.137,11.609,0,0-14.178.488-21.605-9.059l17.027-21.587s7.698,3.63,13.052,3.587Z",
    fill: "#d9d9d9",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.09,241.373l-18.229-16.758,5.049-5.203s1.01-1.448.287-2.355-1.353-3.615.051-5.142c1.404-1.527,4.339-.972,5.941,2.118,1.77-1.519,2.704-2.415,2.704-2.415,0,0,2.602-2.82,5.495-1.113,2.893,1.707-1.98,7.955-1.98,7.955,0,0,2.843-4.515,3.932-4.987,1.09-.472,1.831-.839,3.207.305s2.093,2.806-1.721,8.913c0,0,2.092-4.107,3.542-4.539,1.451-.432,1.911-.441,3.652.833,1.74,1.274,1.523,5.674-2.548,10.891-4.071,5.217-9.38,11.496-9.38,11.496Z",
    fill: "#5e5b5c",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.813,228.37l-33.663-15.088-2.112-.947-33.754-15.128c-24.279,16.516-37.92,75.096-37.92,75.096l37.303,16.719,2.112.947,37.203,16.674s34.623-49.175,30.831-78.273Z",
    fill: "#36a7df",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m217.585,209.683s-7.374,8.655-4.846,15.748l-13.889,12.268s-7.898-6.817-6.303-21.762c2.088-19.558,15.155-29.575,15.155-29.575,0,0,10.03-10.531,22.06-7.887l-.137,21.524s-7.501,4.594-12.039,9.683Z",
    fill: "#d9d9d9",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.909,238.817l18.143-16.851,4.789,5.443s1.364,1.121,2.325.471,3.71-1.063,5.121.457c1.411,1.52.627,4.402-2.579,5.755,1.375,1.884,2.194,2.886,2.194,2.886,0,0,2.606,2.816.676,5.566-1.93,2.749-7.774-2.601-7.774-2.601,0,0,4.277,3.19,4.661,4.313.384,1.123.692,1.892-.557,3.173-1.249,1.281-2.962,1.866-8.749-2.419,0,0,3.929,2.409,4.245,3.889.316,1.48.289,1.94-1.118,3.575-1.407,1.634-5.777,1.071-10.656-3.399s-10.72-10.258-10.72-10.258Z",
    fill: "#5e5b5c",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168.033,
    y: 109.55,
    width: 182.232,
    height: 182.232,
    transform: "translate(104.737 -88.44) rotate(24.142)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.008,
    cy: 215.085,
    rx: 15.299,
    ry: 36.751,
    transform: "translate(-46.744 357.995) rotate(-65.858)",
    fill: "#fcc100",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.531,
    cy: 211.686,
    rx: 12.972,
    ry: 33.529,
    transform: "translate(-42.742 357.376) rotate(-65.858)",
    fill: "#fcc100",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("path", {
    d: "m307.749,171.791c-.002-.007.002-.01-.002-.018-.084-.177-.316-.618-.429-.784-.003-.004-.007,0-.01-.003-2.547-3.834-53.101-26.492-57.657-25.842-.005,0-.004-.006-.009-.006-.199.025-.682.146-.871.201-.008.002-.008.008-.014.011-5.068,1.354-38.217,44.613-36.876,48.185h0s0,0,0,.001c.056.147.203.502.326.601,36.671,29.446,78.552,38.009,83.446,37.402,0,0,0,0,0,0,.157-.017.522-.101.669-.157,0,0,0,0,0-.001,3.559-1.389,13.788-54.907,11.426-59.59Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m219.694,187.488l-2.993-1.341c-1.652-.741-2.392-2.681-1.651-4.333l13.611-22.352c.741-1.652,2.681-2.392,4.333-1.651h0c1.652.741,2.392,2.681,1.651,4.333l-10.619,23.693c-.741,1.652-2.681,2.392-4.333,1.651Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.716,
    cy: 164.307,
    r: 2.886,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.649,
    cy: 176.244,
    r: 2.886,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m295.242,221.348l2.993,1.341c1.652.741,3.592.001,4.333-1.651l7.627-25.034c.741-1.652.001-3.592-1.651-4.333h0c-1.652-.741-3.592-.002-4.333,1.651l-10.619,23.693c-.741,1.652-.001,3.592,1.651,4.333Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.537,
    cy: 201.427,
    r: 2.886,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.33,
    cy: 214.645,
    r: 2.886,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.152
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m289.899,175.685c-8.239-16.535-30.038-21.259-44.093-7.874-10.687,10.177-12.052,26.939-3.162,38.71,4.858,6.432,11.361,10.159,19.385,11.031,12.471,1.355,23.616-5.979,28.29-16.528,3.935-8.321,3.32-17.832-.421-25.339Z",
    fill: "#494444",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.899,175.685c-8.239-16.535-30.038-21.259-44.093-7.874-10.687,10.177-12.052,26.939-3.162,38.71,4.858,6.432,11.361,10.159,19.385,11.031,12.471,1.355,23.616-5.979,28.29-16.528,3.935-8.321,3.32-17.832-.421-25.339Z",
    fill: "#2b2422",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.802,166.69c1.991,4.531.295,5.928-3.77,3.104,0,0-8.611-5.982-24.382-13.051-15.771-7.068-26.949-9.864-26.949-9.864-4.802-1.201-4.879-3.434-.171-4.963l24.223-7.866c4.708-1.529,10.499-1.91,12.87-.847,2.371,1.063,5.94,5.639,7.932,10.171l10.247,23.316Z",
    fill: "#e4201e",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m289.899,175.685c-8.239-16.535-30.038-21.259-44.093-7.874-10.687,10.177-12.052,26.939-3.162,38.71,4.858,6.432,11.361,10.159,19.385,11.031,12.471,1.355,23.616-5.979,28.29-16.528,3.935-8.321,3.32-17.832-.421-25.339Z",
    fill: "#f0a3c7",
    stroke: "#12100b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.15,205.406c-2.138-.942-3.497-2.487-3.72-4.88-.034-.367.006-.784.156-1.111.103-.224.455-.456.699-.46.239-.003.604.226.698.446.209.488.272,1.037.415,1.555.432,1.573,1.597,2.411,3.04,2.907.767.264,1.518.122,2.152-.455.396-.361.787-.746,1.244-1.012.207-.12.628-.072.843.068.346.225.452.669.225,1.025-1.393,2.181-3.572,2.944-5.753,1.916Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.055,194.545c.094-.698.214-1.286.246-1.878.107-1.988.183-3.979.273-5.968.017-.382.014-.77.079-1.144.068-.388.263-.718.705-.793.393-.067.761.346.809.911.02.228.026.46.015.688-.125,2.6-.245,5.201-.389,7.8-.025.454-.102.919-.244,1.35-.155.47-.55.779-1.052.724-.679-.074-1.371-.18-2.014-.401-.867-.298-1.701-.698-2.532-1.091-.694-.329-.961-.757-.824-1.19.154-.489.751-.601,1.596-.262.64.256,1.257.572,1.898.824.415.163.856.261,1.434.432Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 280.638,
    cy: 188.171,
    r: 7.555,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.638,
    cy: 188.171,
    r: 3.162
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.822,
    cy: 177.049,
    r: 7.555,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.822,
    cy: 177.049,
    r: 3.162
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.282,
    cy: 182.634,
    r: 7.555,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.152
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.282,
    cy: 182.634,
    r: 3.162
  })))))), /*#__PURE__*/React.createElement("circle", {
    cx: 224.748,
    cy: 96.186,
    r: 2.174,
    fill: "#e6e7e7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.751,
    cy: 188.803,
    r: 2.174,
    fill: "#e6e7e7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.446 15.817 215.169 15.93 207.599 15.936 202.824 15.94 203.048 296.222 215.393 296.212 215.176 24.762 356.453 24.649 356.446 15.817",
    fill: "#faee8f",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.583 1.276 202.812 1.415 198.619 1.419 183.245 1.431 183.481 296.237 203.048 296.222 202.824 15.94 376.595 15.801 376.583 1.276",
    fill: "#fdd900",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.327 1.209 347.499 15.824 347.723 296.106 461.578 314.072 461.327 1.209",
    fill: "#fdd900",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.917 159.669 370.009 159.69 369.912 38.401 395.817 35.154 395.917 159.669",
    fill: "#faee8f",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.546 159.637 410.638 159.658 410.537 33.403 436.443 30.277 436.546 159.637",
    fill: "#faee8f",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.012 278.061 370.101 274.89 370.037 195.833 395.946 195.813 396.012 278.061",
    fill: "#faee8f",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.645 283.473 410.734 279.995 410.667 195.801 436.575 195.78 436.645 283.473",
    fill: "#faee8f",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.488,
    cy: 177.675,
    r: 10.424,
    fill: "#f6ac41",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.112,
    cy: 177.678,
    r: 6.255,
    fill: "#f6ac41",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.644,
    cy: 177.687,
    r: 9.929,
    fill: "#f6ac41",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.476,
    y: 283.61,
    width: 164.242,
    height: 12.562,
    fill: "#fdd900",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.789 310.875 461.578 314.072 461.327 1.209 470.667 4.538 473.789 310.875",
    fill: "#fdd900",
    stroke: "#221e20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.417
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMocaDoor4);
export default __webpack_public_path__ + "static/media/moca-door-4.5cff062107146729af26d01a06f868dc.svg";
export { ForwardRef as ReactComponent };